import type PaginationFilter from '../../../common/search/store/PaginationFilter';
import searchMapEvents from '../../../events/searchMapEvents';

export default class SearchMapToLimitFilterConnector {
    static MAP_RESULTS_LIMIT = 50;

    static LIST_RESULTS_LIMIT = 20;

    static connect(paginationFilter: PaginationFilter): void {
        document.addEventListener(searchMapEvents.opened, () => {
            paginationFilter.setPagination(0, SearchMapToLimitFilterConnector.MAP_RESULTS_LIMIT);
        });

        document.addEventListener(searchMapEvents.closed, () => {
            paginationFilter.setPagination(0, SearchMapToLimitFilterConnector.LIST_RESULTS_LIMIT);
        });
    }
}
